import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

const useGetCurrentUser = () => {
  const { currentUser } = useRemoteBoundStore();

  const userId = currentUser?.userId;
  const practiceId = currentUser?.currentRole?.practice?.practiceId;
  const userType = currentUser?.currentRole?.role;
  const fullName = currentUser?.fullName;

  const userEmail = currentUser?.emailAddress;

  return {
    currentUser,
    userId,
    practiceId,
    userType,
    fullName,
    userEmail,
  };
};

export default useGetCurrentUser;
